<template>
  <table class="table">
    <thead>
      <tr>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td
          v-for="rideType in rideTypes"
          :key="rideType.value"
          class="text-center"
          v-text="rideType.label"
        />
      </tr>
    </thead>
    <tbody>
      <tr v-for="vehicle in vehicles" :key="vehicle.id">
        <td class="text-center">
          <div>
            <img
              v-if="vehicle.image && vehicle.image"
              :src="thumb(vehicle.image, 120)"
              :alt="vehicle.name"
              style="width: 120px"
            />
          </div>
          {{ vehicle.name }}
        </td>
        <td>
          <template v-for="(value, attr) in vehicle.attributes">
            <p v-if="value" :key="attr" class="text-nowrap">
              {{ $t(`vehicles.attributes.${attr}.label`) }}:
              {{ value }}
            </p>
          </template>
        </td>
        <td
          v-for="rideType in rideTypes"
          :key="`${vehicle.id}_${rideType.value}`"
          class="text-center"
        >
          <input
            v-if="vehicle.ride_types.includes(rideType.value)"
            v-model="model[rideType.value]"
            :value="vehicle.id"
            type="checkbox"
          />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'VehiclesListEdit',

  props: {
    rideTypes: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    vehicles: {
      required: true,
      type: Array,
    },
  },

  data() {
    return {
      model: {},
    }
  },

  watch: {
    model() {
      this.$emit('input', this.model)
    },
  },

  created() {
    this.model = this.value
  },
}
</script>
